import { render, staticRenderFns } from "./ProposalNameCell.vue?vue&type=template&id=b5d09dd8&scoped=true"
import script from "./ProposalNameCell.vue?vue&type=script&lang=js"
export * from "./ProposalNameCell.vue?vue&type=script&lang=js"
import style0 from "./ProposalNameCell.vue?vue&type=style&index=0&id=b5d09dd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d09dd8",
  null
  
)

export default component.exports